import loadInitialConversationsFromServer from './helpers/loadInitialConversationsFromServer';
import loadInitialItemsFromServer from './helpers/loadInitialItemsFromServer';
import { trace } from 'owa-trace';
import { action } from 'satcheljs/lib/legacy';
/**
 * @param tableView to load rows in
 * @param OnInitialTableLoadComplete is a callback that is called when we receive the response
 * The callback is handled by table loading
 * @param isTablePrefetched indicates if the table is prefetched
 * @return a promise that resolves when the load table from server has completed
 */
export default action('loadInitialRowsFromServer')(function loadInitialRowsFromServer(tableView, isTablePrefetched, onInitialTableLoadComplete) {
    tableView.isLoading = true;
    tableView.loadErrorStatus = 0 /* None */;
    switch (tableView.tableQuery.listViewType) {
        case 0 /* Conversation */:
            return loadInitialConversationsFromServer(tableView, isTablePrefetched, onInitialTableLoadComplete);
        case 1 /* Message */:
            return loadInitialItemsFromServer(tableView, isTablePrefetched, onInitialTableLoadComplete);
        default:
            trace.warn('listViewType: ' + tableView.tableQuery.listViewType + ' is not supported.');
            return Promise.resolve();
    }
});
//# sourceMappingURL=loadInitialRowsFromServer.js.map